"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Snackbars = exports.withSnackbarsContext = exports.SnackbarsContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const classnames_1 = __importDefault(require("classnames"));
const react_jss_1 = __importDefault(require("react-jss"));
const icons_1 = require("../../icons");
const text_1 = require("../../utils/text");
const types_1 = require("../../constant/types");
const snackbars_style_1 = __importDefault(require("./snackbars.style"));
exports.SnackbarsContext = react_1.default.createContext(() => { });
const withSnackbarsContext = Component => props => (jsx_runtime_1.jsx(exports.SnackbarsContext.Consumer, { children: ({ successSnackbar, errorSnackbar, closeSnackbars }) => (jsx_runtime_1.jsx(Component, Object.assign({ successSnackbar: successSnackbar, errorSnackbar: errorSnackbar, closeSnackbars: closeSnackbars }, props), void 0)) }, void 0));
exports.withSnackbarsContext = withSnackbarsContext;
const defaultState = {
    messages: [],
    // We keep last message for display purposes, so that the message is still
    // written in the component during the transition.
    lastMessage: { message: '', type: '' },
    // is the component ready to display a new message, i.e. the last message has been already hidden.
    isReady: true
};
class Snackbars extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.state = defaultState;
        this.componentDidUpdate = () => {
            const { isReady, messages } = this.state;
            if (!isReady || !messages.length)
                return;
            const msgs = [...messages];
            const msg = msgs.shift();
            this.setState({ messages: msgs, lastMessage: msg, isReady: false });
            this.timer = setTimeout(this.onReady, msg.timeout || types_1.SNACKBAR_TIMEOUT);
        };
        this.componentWillUnmount = () => {
            if (this.timer)
                clearTimeout(this.timer);
        };
        this.onAddAlert = (msg, clearStack) => {
            const { messages, isReady } = this.state;
            if (clearStack || (isReady && !messages.length)) {
                this.setState({
                    lastMessage: msg,
                    isReady: false,
                    messages: clearStack ? [] : messages
                });
                if (clearStack)
                    clearTimeout(this.timer);
                this.timer = setTimeout(this.onReady, msg.timeout || types_1.SNACKBAR_TIMEOUT);
            }
            else {
                this.setState({ messages: [...messages, msg] });
            }
        };
        this.onAddSuccessAlert = (message, label, onClick, timeout, clearStack) => this.onAddAlert({ message, label, onClick, timeout }, clearStack);
        this.onAddErrorAlert = (message, timeout, clearStack) => this.onAddAlert({ message, type: types_1.TYPE_ERROR, timeout }, clearStack);
        this.closeAll = () => {
            this.setState(defaultState);
            clearTimeout(this.timer);
        };
        this.onReady = () => {
            this.setState({ isReady: true });
        };
        this.handleClose = () => {
            // if the snackbar is closed manually by clicking on the cross
            this.onReady();
            clearTimeout(this.timer);
        };
        this.handleClick = () => {
            const { lastMessage: { onClick } } = this.state;
            onClick();
            this.setState({ isReady: true });
            clearTimeout(this.timer);
        };
        this.renderMessage = () => {
            const { classes } = this.props;
            const { lastMessage, isReady } = this.state;
            const rootClasses = classnames_1.default({
                [classes.root]: true,
                [classes.ready]: isReady,
                [classes.error]: lastMessage.type === types_1.TYPE_ERROR
            });
            const snackbarClasses = classnames_1.default({
                [classes.message]: true
            });
            const dataCy = `atomic-snackbar-${lastMessage.type === types_1.TYPE_ERROR ? 'error' : 'success'}`;
            return (jsx_runtime_1.jsxs("div", Object.assign({ className: rootClasses }, { children: [jsx_runtime_1.jsx("button", Object.assign({ className: classes.btn, onClick: this.handleClose, "data-cy": "close-btn" }, { children: jsx_runtime_1.jsx(icons_1.Icon, { name: "Cross", size: 32 }, void 0) }), void 0),
                    jsx_runtime_1.jsx("div", Object.assign({ "data-cy": dataCy, className: snackbarClasses }, { children: text_1.parseBoldMarkdown(lastMessage.message) }), void 0),
                    lastMessage.onClick && lastMessage.label && (jsx_runtime_1.jsx("button", Object.assign({ className: classes.clickBtn, onClick: this.handleClick }, { children: lastMessage.label }), void 0))] }), void 0));
        };
    }
    render() {
        return (jsx_runtime_1.jsxs(exports.SnackbarsContext.Provider, Object.assign({ value: {
                successSnackbar: this.onAddSuccessAlert,
                errorSnackbar: this.onAddErrorAlert,
                closeSnackbars: this.closeAll
            } }, { children: [this.props.children, this.renderMessage()] }), void 0));
    }
}
exports.Snackbars = Snackbars;
Snackbars.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    children: prop_types_1.default.node.isRequired
};
exports.default = react_jss_1.default(snackbars_style_1.default)(Snackbars);
//# sourceMappingURL=index.js.map